import { Device } from './device.model';
import { Parameter } from './parameter.model';

export function limitedRangeSystemIdentificationParameterId(
  limitedRangeSystemIdentificationParameter: Partial<LimitedRangeSystemIdentificationParameter> | string,
  device: Device | string,
) {
  const limitedRangeSystemIdentificationParameterFieldName =
    typeof limitedRangeSystemIdentificationParameter === 'string'
      ? limitedRangeSystemIdentificationParameter
      : limitedRangeSystemIdentificationParameter.fieldName;
  const deviceSerialNumber = typeof device === 'string' ? device : device.serialNumber;

  return `${limitedRangeSystemIdentificationParameterFieldName}.${deviceSerialNumber}`;
}

export interface LimitedRangeSystemIdentificationParameter extends Parameter {
  /**
   * Belongs to Device [FK].
   */
  deviceSerialNumber: string;
}

export const allLimitedRangeSystemIdentificationParameters: Partial<LimitedRangeSystemIdentificationParameter>[] = [
  {
    defaultData: 1000000,
    description: `
    <p>This parameter defines the permissible motion window around the initial position when the system identification process starts. The value is specified in position units and applies symmetrically in both directions; therefore, the total window width is twice the defined range limit.</p>
    <p>Motion range limits that are too restrictive lead to aggressive control action in order to keep the load within the specified limits.</p>
    `,
    fieldName: 'rangeLimit',
    uintValue: 1000000,
    group: 'Limited Range System Identification',
    inputType: 'number',
    mandatory: true,
    max: 4294967295,
    min: 1000,
    name: 'Range Limit',
    typeValue: 'uintValue',
    unit: 'Inc',
    value: 1000000,
    writeAccess: true,
    isBeta: true,
  },
];
